export type SessionRedirectOptionsT = {
  no401redirect?: boolean;
  noEmailVerifiedRedirect?: boolean;
};

type ClearableSessionT = {
  clear(): void;
};

export const isUnauthorizedStatus = (status: unknown): boolean => {
  return status === 401 || status === "unauthorized";
};

export const isForbiddenStatus = (status: unknown): boolean => {
  return status === 403 || status === "forbidden";
};

export const handleUnauthorized = (session: ClearableSessionT | null, options: SessionRedirectOptionsT = {}): void => {
  if (options.no401redirect) {
    return;
  }

  session?.clear();

  if (window.location.pathname.startsWith("/login")) {
    return;
  }

  const loginRedirect = encodeURIComponent(window.location.pathname + window.location.search);
  window.location.href = `/login?alr=${loginRedirect}`;
};

export const handleEmailNotVerified = (): boolean => {
  if (window.location.pathname.startsWith("/verify-email")) {
    return true;
  }

  window.location.href = "/verify-email-required";
  return true;
};
